// extracted by mini-css-extract-plugin
module.exports = {"button":"step2_button_DIq_8","step__button":"step2_step__button_1qxFx","button_type":"step2_button_type_3cOGS","step__buttons":"step2_step__buttons_3z6iL"};